package app.smartcoding.realrate.domain.model.creditCardField

import app.smartcoding.realrate.domain.model.ErrorType
import kotlin.jvm.JvmInline

sealed interface Loan {
    @JvmInline
    value class TaxRate(val value: Double) : Loan

    @JvmInline
    value class TaxFee(val value: Double) : Loan

    @JvmInline
    value class RequestedAmount(val value: Double) : Loan

    @JvmInline
    value class ReceivedAmount(val value: Double) : Loan

    @JvmInline
    value class Error(val error: ErrorType) : Loan
}